/* eslint-disable react-hooks/exhaustive-deps  */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useForm, Controller } from 'react-hook-form';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Rules } from '../../../helpers/RHFRules';
import { getApplicationName } from '../../../helpers/generalUtils';

import {
  validationMailCodeAction,
  approveMailCodeAction,
  checkIsValidEmailAction,
  changeConfirmEmailAction,
} from '../../../actions/purchaseLicense.action';

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: theme.statusLicense.containerMessage.backgroundColor,
  },
  form: {
    paddingBottom: '20px',
  },
  dialogTitle: {
    backgroundColor: theme.statusLicense.containerMessage.backgroundColor,
  },
  resendEmailLink: {
    ...theme.resendEmailLink,
  },
  titleModal: {
    ...theme.home.cart.title,
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 20,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(-0.6),
    top: theme.spacing(-0.6),
  },
  spacingContent: {
    paddingBottom: '7%',
    fontSize: '16px',
    fontWeight: 400,
    ...theme.home.cart.spacingContent,
  },
  formErrors: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(13),
  },
  btn: {
    ...theme.verifyEmailLink,
    fontSize: 14,
    width: '45%',
    borderRadius: '7px',
  },
  typeInput: {
    '& .MuiOutlinedInput-root': {
      ...theme.registerForm.typeInputValidationCode,
    },
    '& .MuiInputLabel-root': {
      color: theme.registerForm.colorLabelValidationCode,
      marginLeft: '25%',
      marginTop: '1%',
      [theme.breakpoints.between('0', '600')]: {
        marginLeft: 0,
      },
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: theme.registerForm.colorInputError,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      ...theme.registerForm.colorBorderNormalValidationCode,
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      ...theme.registerForm.colorBorderError,
    },
    '& .MuiInputLabel-shrink': {
      marginLeft: 0,
      marginTop: 0,
    },
  },
  menuButton: {
    ...theme.registerForm.handleBackMenuButton,
  },
  dialogStyle: {
    backgroundColor: theme.statusLicense.containerMessage.backgroundColor,
    overflow: 'hidden',
    borderRadius: '10px',
  },
  tamIcon: {
    transform: 'scale(0.85)',
  },
}));

const ValidationCodeModal = (props) => {
  const classes = useStyles();
  const {
    isOpen, onClose,
    email, validationMailCode,
    validityCode, approveMailCode,
    getValidationCodeError, appName,
    checkIsValidEmail, changeConfirmEmail,
    confirmEmail,
  } = props;

  const [loading, setLoading] = useState(false);
  const [resendEmailCode, setResendEmailCode] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailConfirm, setEmailConfirm] = useState('');
  const [resendMail, setResendMail] = useState('');

  const {
    handleSubmit, setValue, getValues, errors, control,
  } = useForm({
    mode: 'onChange',
  });

  const onSubmit = (formData) => {
    setErrorMessage('');
    const vEmail = emailConfirm || email;
    validationMailCode(vEmail, formData.validationCode, setLoading);
  };

  const resendEmail = () => {
    setResendEmailCode(true);
    const vEmail = emailConfirm || email;
    setResendMail(vEmail);
  };

  const handleResendEmail = () => {
    changeConfirmEmail(getValues('email'));
    checkIsValidEmail(getValues('email'), true, appName);
  };

  const handleClearError = () => {
    setErrorMessage('');
  };

  const handleBackSendCode = () => {
    setResendEmailCode(false);
    setErrorMessage('');
    setResendMail('');
  };

  useEffect(() => {
    const vEmail = emailConfirm || email;
    setEmailConfirm(vEmail);
  }, []);

  useEffect(() => {
    if (resendMail !== '') {
      setValue('email', resendMail);
    }
  }, [resendMail]);

  useEffect(() => {
    if (validityCode === true) {
      approveMailCode();
    }
  }, [validityCode]);

  useEffect(() => {
    if (getValidationCodeError) {
      setErrorMessage(getValidationCodeError);
      setValue('validationCode', '');
    }
  }, [getValidationCodeError]);

  useEffect(() => {
    if (confirmEmail) {
      setValue('email', confirmEmail);
      setEmailConfirm(confirmEmail);
    }
  }, [confirmEmail]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={isOpen}
        classes={{ paper: classes.dialogStyle }}
      >
        <br />
        <DialogTitle className={classes.dialogTitle}>
          {
            resendEmailCode && resendEmailCode === true ? (
              <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleBackSendCode}>
                <KeyboardArrowLeftIcon />
              </IconButton>
            ) : (
              <>
              </>
            )
          }
          <Typography className={classes.titleModal}>
            {
              resendEmailCode && resendEmailCode === true ? (
                '¡Hecha un vistazo a tu bandeja de entrada!'
              ) : (
                '¡Solo falta una comprobación más!'
              )
            }
          </Typography>
          <IconButton aria-label="close" color="primary" className={classes.closeButton} onClick={onClose}>
            <CloseIcon className={classes.tamIcon} />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.root}>
          <form
            className={classes.form}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                {
                  resendEmailCode && resendEmailCode === true ? (
                    <Typography className={classes.spacingContent}>
                      {`¿Hemos acertado? esta es la dirección de email que utilizas para ${getApplicationName(appName)}.`}
                    </Typography>
                  ) : (
                    <Typography className={classes.spacingContent}>
                      <div>
                        {`Te hemos enviado un código a ${emailConfirm},`}
                        <br />
                        por favor ingrésalo a continuación
                        <br />
                        (puede haber llegado a tu correo no deseado).
                        <br />
                      </div>
                    </Typography>
                  )
                }
              </Grid>
              <Grid item xs={11}>
                {
                  resendEmailCode && resendEmailCode === true ? (
                    <Controller
                      as={(
                        <TextField
                          size="medium"
                          variant="outlined"
                          label="Email"
                          required
                          fullWidth
                          FormHelperTextProps={{ style: { marginRight: 0 } }}
                          helperText={errors.email ? errors.email.message : ''}
                          className={classes.typeInput}
                        />
                      )}
                      name="email"
                      control={control}
                      rules={Rules.email}
                      error={Boolean(errors.email)}
                      inputProps={{
                        maxLength: 100,
                        style: { textAlign: 'center', fontSize: '16px', fontWeight: 700 },
                      }}
                      defaultValue=""
                    />
                  ) : (
                    <>
                      <Controller
                        as={(
                          <TextField
                            size="medium"
                            variant="outlined"
                            label="Código de verificación"
                            required
                            fullWidth
                            FormHelperTextProps={{ style: { marginRight: 10 } }}
                            inputProps={{
                              style:
                              {
                                paddingBottom: '3%',
                              },
                            }}
                            helperText={errors.validationCode ? errors.validationCode.message : ''}
                            className={classes.typeInput}
                          />
                        )}
                        name="validationCode"
                        control={control}
                        rules={Rules.codigoValidacion}
                        error={Boolean(errors.validationCode)}
                        defaultValue=""
                        inputProps={{
                          maxLength: 6,
                          style:
                          {
                            textAlign: 'center',
                            fontSize: '20px',
                            fontWeight: 400,
                            paddingBottom: '4%',
                          },
                        }}
                        onKeyDown={(e) => handleClearError(e)}
                      />
                      {getValidationCodeError && (
                        <Typography className={classes.formErrors}>
                          {errorMessage}
                        </Typography>
                      )}
                    </>
                  )
                }
              </Grid>
              <Grid item xs={12} className={classes.spacingContent}>
                {
                  resendEmailCode && resendEmailCode === true ? (
                    <>
                    </>
                  ) : (
                    <Link
                      component="button"
                      style={{ fontSize: '15', paddingTop: '8px' }}
                      color="primary"
                      onClick={() => { resendEmail(); }}
                      className={classes.resendEmailLink}
                    >
                      ¿No has recibido el email?
                    </Link>
                  )
                }
              </Grid>
              <Grid item xs={12}>
                {
                  resendEmailCode && resendEmailCode === true ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.btn}
                      onClick={() => {
                        handleResendEmail();
                      }}
                    >
                      Reenviar
                      {loading && <CircularProgress color="secondary" size={25} />}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.btn}
                    >
                      Verificar
                      {loading && <CircularProgress color="secondary" size={25} />}
                    </Button>
                  )
                }
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (props) => ({
  validityCode: props.purchaseLicense.validityCode,
  confirmEmail: props.purchaseLicense.confirmEmail,
  getValidationCodeError: props.purchaseLicense.getValidationCodeError,
});

const mapDispatchToProps = {
  validationMailCode: validationMailCodeAction,
  approveMailCode: approveMailCodeAction,
  checkIsValidEmail: checkIsValidEmailAction,
  changeConfirmEmail: changeConfirmEmailAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidationCodeModal);
